import { Suggestion } from '@/features/assistant/components/SuggestionCards';
import { ROUTES } from '@/utils/routeUtils';

/**
 * Chat status constants
 * These values represent the different states of a chat conversation
 */
export const CHAT_STATUS = {
  ERROR: 'error',
  IDLE: 'idle',
  READY: 'ready',
  STREAMING: 'streaming',
  SUBMITTED: 'submitted',
} as const;

export type ChatStatus = (typeof CHAT_STATUS)[keyof typeof CHAT_STATUS];

/**
 * Accepted file types for file uploads
 */
export const ACCEPTED_FILE_TYPES: Array<string> = [
  '.pdf',
  '.doc',
  '.docx',
  '.eml',
  '.png',
  '.jpg',
  '.jpeg',
  '.tiff',
  '.bmp',
];

export const DEFAULT_SUGGESTIONS: Array<Suggestion> = [
  {
    icon: 'checklist',
    id: 'key-issues',
    title: 'Check for data accuracy',
    titleKey: 'assistant.suggestions.checkDataAccuracy',
  },
  {
    icon: 'clock',
    id: 'closing-checklist',
    title: 'Verify user feedback implementation',
    titleKey: 'assistant.suggestions.verifyFeedback',
  },
  {
    icon: 'clock',
    id: 'feedback-2',
    title: 'Verify user feedback implementation',
    titleKey: 'assistant.suggestions.verifyFeedback',
  },
];

/**
 * Date range filter options for narratives
 */
export type DateRangeFilter = 'today' | 'week' | 'custom';

export const DATE_RANGE_OPTIONS = [
  { labelKey: 'narrative.dateRange.today', value: 'today' as DateRangeFilter },
  { labelKey: 'narrative.dateRange.week', value: 'week' as DateRangeFilter },
  { labelKey: 'narrative.dateRange.custom', value: 'custom' as DateRangeFilter },
];

/**
 * Maps DateRangeFilter to NarrativeJob.type for API requests.
 */
export const getNarrativeType = (filter: DateRangeFilter): 'TODAY' | 'WEEK' | 'CUSTOM' => {
  if (filter === 'today') {
    return 'TODAY';
  }
  if (filter === 'week') {
    return 'WEEK';
  }
  return 'CUSTOM';
};

/**
 * Routes where the bottom tabs should be visible.
 */
export const APP_HEADER_TABS_VISIBLE_PATHS = [ROUTES.ASSISTANT, ROUTES.NARRATIVE] as const;

export const USER_NAME_LOCAL_STORAGE_KEY = 'user_display_name';
